<app-back-to-integrations-button></app-back-to-integrations-button>
<div class="page-content">
	<div>
		<img src="/assets/images/integrations/treefort-logo.svg" />
	</div>
	<div class="mb-10">
		<h2>Treefort</h2>
		<p class="mt-5">
			Access Treefort's digital identity & fraud prevention technology within
			Closer for seamless and secure client verification.
		</p>

		<div class="mt-5">
			<app-button
				*ngIf="
					idvProviderSelected !== idvProvider.TREEFORT;
					else showDisconnectButton
				"
				[matTooltip]="renderTooltipString"
				matTooltipPosition="below"
				[disabled]="!isLoggedInUserAdmin"
				(click)="openTreefortOnboardingModal()"
				btn="primary"
				size="small"
				>Connect</app-button
			>
		</div>
		<app-treefort-promotion-banner></app-treefort-promotion-banner>
		<app-profile-benefits
			[shouldDisplayDivider]="false"
			[benefits]="benefits"
		></app-profile-benefits>
	</div>
	<div>
		<app-container type="dark" class="mb-8">
			<h4>Resources</h4>
			<div class="text-sm flex flex-col gap-2">
				<div class="flex gap-2">
					<app-icon [icon]="ICON.FILE"></app-icon>
					<div class="flex flex-col">
						<span class="font-bold">Treefort Website</span>
						<a
							externalNavInterceptor
							href="https://treeforttech.com/"
							target="_blank"
							class="text-gray-400 hover:underline"
						>
							Learn more about Treefort
						</a>
					</div>
				</div>
				<div *ngIf="shouldRenderReportLinks()" class="flex gap-2">
					<app-icon [icon]="ICON.USER"></app-icon>
					<div class="flex flex-col">
						<span class="font-bold">My reports</span>
						<a
							[href]="idvListUrl"
							(click)="goToMyTreefortReports($event)"
							class="text-gray-400 hover:underline"
						>
							View my Treefort reports
						</a>
					</div>
				</div>
				<app-anchor
					*ngIf="shouldRenderReportLinks()"
					[url]="idvListUrl"
					[icon]="ICON.EXTERNAL"
					type="pill-alt"
					class="self-center"
					>View reports</app-anchor
				>
			</div>
		</app-container>
		<app-container title="Contact Info">
			<div class="text-sm flex flex-col gap-2 mb-4">
				<div class="flex gap-2">
					<app-icon [icon]="ICON.PHONE"></app-icon>
					<a
						externalNavInterceptor
						href="tel:1-866-785-0270"
						target="_blank"
						class="hover:underline"
						>1-866-785-0270</a
					>
				</div>
				<div class="flex gap-2">
					<app-icon [icon]="ICON.CLOCK"></app-icon>
					<p>8am - 8pm ET</p>
				</div>
				<div class="flex gap-2">
					<app-icon [icon]="ICON.EMAIL"></app-icon>
					<a
						emailLinkInterceptor
						href="mailto:support@treeforttech.com"
						class="hover:underline"
						>support&#64;treeforttech.com</a
					>
				</div>
			</div>
		</app-container>
	</div>
</div>

<ng-template #showDisconnectButton>
	<app-button
		(click)="disconnectTreefortIntegration()"
		btn="border"
		size="small"
		>Disconnect</app-button
	>
</ng-template>
